function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { BaseTile as BaseTileComponent } from '@shared/components/baseTile';
import { connect } from 'react-redux';
const mapStateToProps = (state, ownProps)=>{
    const { activeFilters: appsActiveFilters, count: appsCount } = state.apps;
    const { activeFilters: servicesActiveFilters, count: servicesCount } = state.services;
    const { currentView, query, requestId: searchReqId, isEmbedded } = state.config;
    return _object_spread_props(_object_spread({}, ownProps), {
        isLoadingUserData: state.users.loading,
        activeFilters: currentView === 'appGallery' ? appsActiveFilters : servicesActiveFilters,
        count: currentView === 'appGallery' ? appsCount : servicesCount,
        searchReqId,
        searchSortingBy: query.sortBy,
        isEmbedded
    });
};
export const BaseTile = connect(mapStateToProps, null)(BaseTileComponent);
